import { useUpdateManagementCompany } from "src/services/admin/commands/managementCompanies";
import SnackbarUtils from "src/utils/SnackbarUtils";

import { ManagementCompany } from "../../types";

export const useSaveManageCompany = () => {
	const onSuccess = () => {
		SnackbarUtils.success("Se ha guardado la gestora.");
	};

	const onError = () => {
		SnackbarUtils.error("Se ha producido un error al intentar guardar la gestora.");
	};

	const { mutate, isPending } = useUpdateManagementCompany();

	const onSave = (company: ManagementCompany) => {
		mutate(company, { onSuccess, onError });
	};

	return { onSave, isLoading: isPending };
};
